import { Ifo } from './types'

const ifos: Ifo[] = [
  {
    id: 'paw',
    // Ethereum mainnet PAW sale (IDO.sol): 5,124,000 PAW at a fixed price for up to 30,000 USDC,
    // 2026-10-12 12:00 to 2026-10-13 12:00 UTC
    address: '0x521F85FE0F25874B0df777830E0C8B5d0e0767dB',
    isActive: true,
    isPrivate: false,
    name: 'SUPAW Launch',
    description:
      '$PAW is the fuel powering the SUPAW ecosystem on Supra, bringing together GameFi, staking, NFTs and community-driven utilities.\n\nOfficial TCG Website is in development for testnet.',
    launchDate: 'Oct. 12',
    launchTime: '12:00 PM UTC',
    startTime: 1791806400, // 2026-10-12 12:00 UTC
    endTime: 1791806400 + 24 * 60 * 60, // 24-hour sale
    saleAmount: '5,124,000 PAW',
    raiseAmount: '$30,000',
    raisingAmount: 30000, // 30,000 USDC goal, so the page doesn't read it from the contract
    cakeToBurn: '$0',
    projectSiteUrl: 'https://supaw.gitbook.io/supaw',
    telegramUrl: 'https://t.me/+pEcyGsPjSiZiNDc9',
    xUrl: 'https://x.com/Supaw_Sup',
    currency: 'USDC',
    currencyAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    currencyDecimals: 6,
    tokenDecimals: 18,
    tokenSymbol: 'PAW',
    releaseTime: 1791720000, // 2026-10-11 12:00 UTC, before the sale starts
    campaignId: '511070000',
    maxDepositAmount: 0, // no limit per wallet
    vestingPercentage: 0, // IDO.sol has no vesting; 0 also keeps the page off the vesting functions it lacks
  },
  {
    id: 'toon',
    // Ethereum mainnet TOON sale (IDO.sol): 2026-10-04 00:00 to 2026-10-05 00:00 UTC
    address: '0x5Df67354Cca11C235c2FDc7559572dd1dE53ca69',
    isActive: false,
    isPrivate: false,
    name: 'TOON Launch',
    description:
      'ToonSwap is building on Ethereum to connect the Supra community with a broader DeFi environment, where users can swap assets, provide liquidity, participate in community farms, earn points, and invite others through its referral system.\n\n🎁 Early Bird: First $50K gets +10% $TOON',
    launchDate: 'Oct. 4',
    launchTime: '12:00 PM UTC',
    startTime: 1791115200, // 2026-10-04 00:00 UTC
    endTime: 1791115200 + 24 * 60 * 60, // 24-hour sale
    saleAmount: '600,000 TOON',
    raiseAmount: '$50,000', // no longer shown: a fair launch has no target
    cakeToBurn: '$1,500,000',
    projectSiteUrl: 'https://toonswap.xyz/',
    telegramUrl: 'https://t.me/toonswapsupra',
    xUrl: 'https://x.com/toonswapsupra',
    currency: 'USDC',
    currencyAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    currencyDecimals: 6,
    tokenDecimals: 18,
    tokenSymbol: 'TOON',
    releaseTime: 1790640000, // 2026-09-29 00:00 UTC, before the sale starts
    campaignId: '511080000',
    maxDepositAmount: 5000,
    vestingPercentage: 0, // IDO.sol has no vesting; 0 also keeps the page off the vesting functions it lacks
    isFairLaunch: true,
  },
]

export default ifos
